import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const OutgoingReportsTableRow = ({
  id, // {el.device_id}
  deviceName, // {el.device_name}
  type, // {el.device_type}
  replyTn, // {el.reply_tn}
  txt, // {el.totals.messages_sent}
  dir, // {el.totals.direct_sent}
  rem, // {el.totals.reminders_sent}
}) => (
  <TableRow key={'list' + id} id={id}>
    <TableCell>{deviceName}</TableCell>
    <TableCell>{type}</TableCell>
    <TableCell>{replyTn}</TableCell>
    <TableCell>{txt}</TableCell>
    <TableCell>{dir}</TableCell>
    <TableCell>{rem}</TableCell>
  </TableRow>
);

export default OutgoingReportsTableRow;
